import Vue from "vue";
import VueRouter from "vue-router";
import pages from "./routes/pages";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: "/", redirect: { name: "secure-payment-form" } },
    ...pages,
  ],
});

router.beforeEach(async (to, from, next) => {
  return next();
});

router.afterEach(() => {
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
